module.exports = __webpack_public_path__ + "static/img/wenhua13.4e1027e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wenhua13.jpg
// module id = /fTp
// module chunks = 1